export const companyNameInitialsOverrideMap = {
  'Target Dedicated': 'TAD',
}

export const initials = (name, onlyName) => {
  if (!name) return '??'
  if (onlyName) return name[0].toUpperCase()
  const parts = name.split(' ')
  const first = parts.shift()
  const last = parts.pop()
  return `${first[0]}${last ? last[0] : first[1]}`.toUpperCase()
}

export const companyNameInitials = (name, length = 3) => {
  if (companyNameInitialsOverrideMap[name]) {
    return companyNameInitialsOverrideMap[name]
  }

  return name ? name.replace(/ /gi, '').substring(0, length).toUpperCase() : ''
}

// converts "Firstname Lastname" => "Firstname L."
export const shortName = (name = '') => {
  const [first, ...rest] = name.split(' ')
  return [first, ...rest.map(word => `${word[0]}.`)].join(' ')
}

export default initials
